<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">

    <!-- Título -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Importar inventário por coletor</h1>
            <p class="welcome-message">
              <button mat-icon-button (click)="clickVoltar()">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Importe seus produtos rapidamente utilizando arquivos padronizados.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Info coletor -->
    <app-alert-card type="info" title="O que é coletor?">
      O coletor é um dispositivo utilizado para ler o código GTIN ou SKU dos itens.
      Após a contagem, exporte um arquivo TXT do equipamento com os códigos coletados
      e importe-o no Sistema ERP para atualizar o estoque.
    </app-alert-card>

    <form [formGroup]="uploadForm">

      <!-- Configuração do arquivo -->
      <div class="section-label">Como deseja configurar o arquivo?</div>
      <div class="config-row">
        <mat-form-field appearance="outline" class="field-sep">
          <mat-label>Separador</mat-label>
          <input matInput formControlName="separador" placeholder=";" maxlength="3" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="field-linha">
          <mat-label>Linha início começa o primeiro registro</mat-label>
          <input matInput formControlName="linhaInicio" [currencyMask]="integerMask" />
        </mat-form-field>
      </div>

      <!-- Validação -->
      <div class="section-label">Como deseja validar o arquivo?</div>
      <mat-radio-group formControlName="tipoValidacao" class="radio-row">
        <mat-radio-button [value]="0">Código de barras (GTIN/EAN)</mat-radio-button>
        <mat-radio-button [value]="1">Código SKU</mat-radio-button>
        <mat-radio-button [value]="2">Código GTIN/EAN ou SKU</mat-radio-button>
      </mat-radio-group>

      <div class="action-card-grid">
        <button type="button" class="action-card-action" (click)="clickDownloadModelo()" [disabled]="_isDownloadingModelo">
          <app-action-card
            [icon]="_isDownloadingModelo ? '' : 'download'"
            title="Download arquivo de exemplo"
            description="Baixe nosso modelo de arquivo TXT para garantir que os dados sejam validados."
            [interactive]="true"
            [disabled]="_isDownloadingModelo">
            @if (_isDownloadingModelo) {
              <mat-progress-spinner actionCardIcon diameter="20" mode="indeterminate"></mat-progress-spinner>
            }
          </app-action-card>
        </button>
      </div>

      <!-- Zona de drop -->
      <div
        class="drop-zone"
        [class.drop-zone--active]="_isDragging"
        [class.drop-zone--file]="_arquivo"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)"
        (click)="fileInput.click()">
        <input #fileInput type="file" accept=".txt" hidden (change)="onFileSelected($event)" />
        @if (_arquivo) {
          <mat-icon class="drop-icon drop-icon--ok">check_circle</mat-icon>
          <p class="drop-title">{{ nomeArquivo() }}</p>
          <p class="drop-subtitle">{{ tamanhoArquivo() }} — clique para trocar</p>
        } @else {
          <mat-icon class="drop-icon">upload_file</mat-icon>
          <p class="drop-title">Clique para enviar ou arraste e solte</p>
          <p class="drop-subtitle">Formatos aceitos: TXT (Tamanho máximo: 2 MB)</p>
        }
      </div>

      <!-- Local destino -->
      <div class="section-label">Qual local deseja definir como padrão para a importação?</div>
      <mat-form-field appearance="outline" class="local-field">
        <mat-label>Local destino</mat-label>
        <mat-select formControlName="idLocalizacaoEstoque">
          @for (loc of _localizacoes; track loc.idLocalizacaoEstoque) {
            <mat-option [value]="loc.idLocalizacaoEstoque">{{ loc.nome }}</mat-option>
          }
        </mat-select>
        @if (uploadForm.get('idLocalizacaoEstoque')?.invalid && uploadForm.get('idLocalizacaoEstoque')?.touched) {
          <mat-error>Selecione o local de destino.</mat-error>
        }
      </mat-form-field>

      <!-- Modo de processamento -->
      <div class="section-label">Como deseja processar o inventário?</div>
      <mat-radio-group formControlName="modoProcessamento" class="radio-col">
        <mat-radio-button [value]="0">Atualizar apenas os produtos do arquivo de importação</mat-radio-button>
        <mat-radio-button [value]="1">Todos os produtos ativos no Sistema</mat-radio-button>
      </mat-radio-group>

      <app-alert-card type="warning">
        Caso opte por todos os produtos, o sistema vai ajustar a quantidade de todos os produtos com base na lista informada. Isso inclui tanto os produtos com diferença de estoque quanto os que ainda não foram conferidos.
      </app-alert-card>

    </form>

    <!-- Rodapé padrão -->
    <app-footer-action
      (salvar)="clickImportar()"
      [isLoadingSalvar]="_isValidating || _isProcessing"
      [isSalvarDisabled]="!_arquivo"
      [hideCancelar]="true"
      salvarLabel="Importar">
    </app-footer-action>

  </div>
</div>
